(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("inversify"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "inversify", "react"], factory);
	else if(typeof exports === 'object')
		exports["InversifyReact"] = factory(require("prop-types"), require("inversify"), require("react"));
	else
		root["InversifyReact"] = factory(root["PropTypes"], root["Inversify"], root["React"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__7__) {
return 